import { useEffect, useState } from 'react';
import enUS from 'date-fns/locale/en-US';
import { type Locale } from '@/i18n';
import { getDateFnsLocaleCode } from '@/i18n';

export const useDateFnsLocale = (i18nlocale: Locale) => {
  const [dateFnsLocale, setDateFnsLocale] = useState(enUS);

  useEffect(() => {
    const importLocaleFile = async () => {
      // This webpack option stops all the date-fns files being imported and chunked.
      const localeToSet = await import(
        /* webpackMode: "lazy", webpackChunkName: "df-[index]", webpackExclude: /_lib/ */
        `date-fns/locale/${getDateFnsLocaleCode(i18nlocale)}/index.js`
      );

      if (localeToSet !== undefined) {
        setDateFnsLocale(localeToSet.default);
      }
    };

    if (dateFnsLocale.code !== i18nlocale) {
      importLocaleFile();
    }
  }, [i18nlocale]);

  return dateFnsLocale;
};

export default useDateFnsLocale;
